import React from 'react';
import Image from 'rt-image';

function SecureImage({ url, jwt }) {
  return <Image src={url} headers={{ Authorization: `Bearer ${jwt}` }} />;
}

export default SecureImage;
